import { tap, shareReplay, BehaviorSubject } from 'rxjs';
import { TermsOfUseGetDto } from './../dtos/termsOfUseGetDto';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { Result, ResultWithValue } from '../../apiResults/result';
import { ServiceResponse } from '../../service-response/serviceResponse';


export const TERMS_OF_USE_API = {
  Get: () => `api/termsofuse`,
  GetByVersion: (
    majorVersion: string | null = '',
    minorVersion: string | null = ''
  ) => `api/termsofuse?major=${majorVersion}&minor=${minorVersion}`,
  GetUserLastMinorVersion: () => `api/termsofuse/UserLastMinorVersion`,
  Accept: () => `api/termsofuse/`,
};

@Injectable({
  providedIn: 'root',
})
export class TermsOfUseService {
  termsOfUseStorageKey = 'TermsOfUseStorageKey';
  refreshUserLastMinorVersionTermsOfUse$ = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) {}

  public getTermsOfUse() {
    const tos = localStorage.getItem(this.termsOfUseStorageKey);
    let response$ = undefined;

    if (tos) {
      response$ = of(JSON.parse(tos) as ResultWithValue<TermsOfUseGetDto>);
      return new ServiceResponse(response$);
    }

    response$ = this.http
      .get<ResultWithValue<TermsOfUseGetDto>>(TERMS_OF_USE_API.Get())
      .pipe(
        tap((tos) => {
          localStorage.setItem(this.termsOfUseStorageKey, JSON.stringify(tos));
        }),
        shareReplay(1),
        catchError((err) => of<ResultWithValue<TermsOfUseGetDto>>(err))
      );

    return new ServiceResponse(response$);
  }

  public getTermsOfUseByVersion(major: string | null, minor: string | null) {
    const response$ = this.http
      .get<ResultWithValue<TermsOfUseGetDto>>(
        TERMS_OF_USE_API.GetByVersion(major, minor)
      )
      .pipe(
        shareReplay(),
        catchError((err) => of<ResultWithValue<TermsOfUseGetDto>>(err))
      );

    return new ServiceResponse(response$);
  }

  public accept() {
    return this.http.patch<Result>(TERMS_OF_USE_API.Accept(), null).pipe(
      catchError((err: HttpErrorResponse) => {
        const fail: Result = {
          isFailure: true,
          isSuccess: false,
          status: err.status,
        };
        return of(fail);
      }),
      tap(() => this.refreshTermsOfUse())
    );
  }

  public refreshTermsOfUse() {
    localStorage.removeItem(this.termsOfUseStorageKey);
  }
}
